<div class="mt-6 w-full px-4 py-4 sm:mt-10 sm:px-8 lg:mt-20 lg:px-16">
  <div class="mt-10 mb-6 sm:mb-8 lg:mt-20 lg:mb-10">
    <h1
      class="mb-2 bg-clip-text text-5xl leading-tight text-transparent lg:text-8xl"
      style="
        background: linear-gradient(
          to bottom,
          #008b79 0%,
          #008c6c 27%,
          #169999 60%,
          #004365 100%
        );
        background-clip: text;
      "
    >
      {{ 'pages.helpPage.title' | translate }}
    </h1>
    <p class="mb-10 text-lg leading-relaxed text-neutral-800">
      {{ 'pages.helpPage.description' | translate }}
    </p>
  </div>
  <!-- Filters Component -->
  <dhp-filters
    class="w-full"
    [categories]="getCategoryNames()"
    [selectedCategory]="selectedCategory()?.name || null"
    (categorySelected)="selectCategory($event)"
  ></dhp-filters>
</div>

<!-- Start of Selection -->
<hr class="mb-6 border-secondary-border sm:mb-10" />
<!-- End of Selection -->

<!-- Display all sections when no category is selected -->
@if (!selectedCategory()) {
  @for (category of categories(); track category) {
    <dhp-questions-section
      [sectionName]="category.name"
      [questions]="category.questions"
    ></dhp-questions-section>
    <div class="my-20"></div>
  }
}

<!-- Display selected section when a specific category is selected -->
@if (selectedCategory(); as category) {
  <dhp-questions-section
    [sectionName]="category.name"
    [questions]="category.questions"
  ></dhp-questions-section>
}
